import { createTheme } from '@mui/material/styles';

const marketingTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      // ORIGINAL
      main: '#edb92e', // Gold accent from marketing site
      light: '#f8c94c',
      dark: '#d4a525',
      // CONCEPT - change gold to blue
      // main: '#2563eb', // Primary blue
      // light: '#dbeafe', // Much lighter blue for backgrounds
      // dark: '#1e40af',
      contrastText: '#000000',
    },
    secondary: {
      main: '#2e2e35', // Dark gray from marketing site
      light: '#3e3e47',
      dark: '#1f1f24',
      contrastText: '#ffffff',
    },
    background: {
      default: '#24242a', // Main dark background
      paper: '#2e2e35', // Card/paper background
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.8)',
    },
    error: {
      main: '#ef4444',
      light: '#fef2f2',
      dark: '#b91c1c',
    },
    warning: {
      main: '#f59e0b',
      light: '#fffbeb',
      dark: '#d97706',
    },
    info: {
      main: '#3b82f6',
      light: '#eff6ff',
      dark: '#2563eb',
    },
    success: {
      main: '#10b981',
      light: '#ecfdf5',
      dark: '#059669',
    },
  },
  typography: {
    fontFamily: '"Source Sans Pro", "Arial", "Helvetica", sans-serif',
    h1: {
      fontSize: '3.75rem',
      fontWeight: 700,
      lineHeight: 1.2,
      color: '#ffffff',
    },
    h2: {
      fontSize: '1.9rem',
      fontWeight: 700,
      lineHeight: 1,
      color: '#ffffff',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 700,
      color: '#ffffff',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: '#ffffff',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
      color: '#ffffff',
    },
    h6: {
      fontSize: '1.1rem',
      fontWeight: 600,
      color: '#ffffff',
    },
    body1: {
      fontSize: '1rem',
      color: 'rgba(255, 255, 255, 0.8)',
    },
    body2: {
      fontSize: '0.9rem',
      color: 'rgba(255, 255, 255, 0.7)',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 7,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#2e2e35',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#2e2e35',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(36, 36, 42, 0.95)',
          backdropFilter: 'blur(10px)',
        },
      },
    },
  },
});

export default marketingTheme;
